// @flow
import type {Node} from 'react'
import React from 'react'

import IconButton from 'components/SideBar/ui/IconButton'

type Props = $ReadOnly<{
  onClick: () => void,
  alt: string,
}>

function QuickAddButton({onClick, alt}: Props): Node {
  return (
    <IconButton onClick={onClick} size="sm" alt={alt}>
      <span className="sidebar--add-icon-container generic">
        <i className="fa fa-plus" />
      </span>
    </IconButton>
  )
}

export default QuickAddButton
